import { useCallback } from 'react';
import { useElecMultirate } from './useElecMultirate';
import { getEnergyUsage } from 'utils/getEnergyUsage';

export const useEnergyUsage = () => {
  const { showE7Tariffs } = useElecMultirate();

  return useCallback(
    (consumptionTypeParam, selectedFuelType, isDualRate = showE7Tariffs) => {
      return getEnergyUsage(consumptionTypeParam, selectedFuelType, isDualRate);
    },
    [showE7Tariffs]
  );
};
